"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const isNil_1 = __importDefault(require("lodash/isNil"));
const NumberUtil_1 = require("../math/NumberUtil");
function getTimeFrom() {
  let from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if ((0, isNil_1.default)(from)) from = 0;
  const currentTime = new Date().getTime();
  return (0, NumberUtil_1.truncateNumberToFixed)((currentTime - from) / 1000, 3);
}
exports.default = getTimeFrom;